<template>
    <resource-overview ref="resOverview"
                       :resource-type="'magazine'"
                       :cates="cates"
                       :rank-data="rankData"
                       :rec-data="recData"
                       :latest-data="latestData"
                       :pull-up-handler="pullUpHandler"
                       :recArticlsData="recommandArticles"/>
</template>

<script>
    import ResourceOverview from '@/components/resourceOverview'

    export default {
        components: {
            ResourceOverview
        },
        data () {
            return {
                cates: [],
                rankData: [],
                recData: [],
                listWithCate: [],
                latestData: [],
                hasResCateIndex: -1,
                recommandArticles:[]
            }
        },
        computed: {
        },
        activated () {
            this.$nextTick(() => {
                this.$refs.resOverview.$emit('refreshBScroll')
            })
        },
        mounted () {
            this.getCatesList()
            this.getDailyRecommend()
            this.getLatestList()
            this.getRankList()
            this.getRecommandArticle();
        },
        methods: {
            async getRecommandArticle () {
                try {
                    debugger
                    const { Data } = await this.$apis('magazine').getDailyRecommendationFromRecentDays()
                    this.recommandArticles = Data;
                } catch (error) {
                    console.log(error)
                }
            },
            async getCatesList () {
                try {
                    const { Data } = await this.$apis('magazine').getCatesList()
                    this.cates = Data
                    this.$nextTick(() => {
                        this.getListByCate(Data[0].CategoryCode, 0)
                        this.getListByCate(Data[1].CategoryCode, 1)
                    })
                } catch (error) {
                    console.log(error)
                }
            },
            async getRankList () {
                try {
                    const { Data } = await this.$apis('magazine').getRankList(1,10)
                    this.rankData = this.$tools.formatMagazineData(Data)
                } catch (error) {
                    console.log(error)
                }
            },
            async getDailyRecommend () {
                try {
                    const { Data } = await this.$apis('magazine').getDailyRecommend()
                    this.recData = this.$tools.formatMagazineData(Data,"-z")
                } catch (error) {
                    console.log(error)
                }
            },
            async getLatestList () {
                try {
                    const { Data } = await this.$apis('magazine').getLatestList(3)
                    this.latestData = this.$tools.formatMagazineData(Data,"-z")
                } catch (error) {
                    console.log(error)
                }
            },
            async getListByCate (categorycode, index = 0, callBack) {
                try {
                    const pageSize = 6
                    const pageIndex = 1
                    const { Data } = await this.$apis('magazine')
                        .getListByCate(categorycode, pageIndex, pageSize)
                    this.cates[index].__resList = this.$tools.formatMagazineData(Data,"-z")
                    this.hasResCateIndex = index
                    if (typeof callBack === 'function') {
                        this.$nextTick(() => {
                            callBack()
                        })
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            pullUpHandler (callBack) {
                const { cates, hasResCateIndex } = this
                if (cates.length <= 0 || hasResCateIndex === -1) {
                    callBack()
                }
                let index = -1
                if (cates[hasResCateIndex].__resList) {
                    index = hasResCateIndex + 1
                }
                if (index !== -1 && index < cates.length) {
                    const categorycode = cates[index].CategoryCode
                    this.getListByCate(categorycode, index, callBack)
                } else {
                    callBack()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
